<!--
右下角浮动按钮
最近更新：20200318
-->
<template>
<div>
  <div class="float_tools">
    <a class="btn btn_scroll_to_top" title="回顶部" @click="funScrolltop" v-show="innerShowScrollToTop"><i class="material-icons">&#xe318;</i></a>
    <router-link class="btn btn_backhome" title="回到首页" :to="backhomeUrl" v-show="innerShowBackHome"><i class="material-icons">&#xe88a;</i></router-link>
    <router-link class="btn btn_search" title="搜索套组" :to="{name: 'SearchSet'}" v-show="innerShowSearchSet"><i class="material-icons">&#xe8b6;</i></router-link>
    <a class="btn btn_feedback" title="反馈" v-show="true" @click="funFeedback(feedbackData)"><i class="material-icons">&#xe560;</i><span>反馈</span></a>
    <!-- <router-link class="btn btn_cart" title="购物车" :to="{name: 'Cart'}" v-show="innerShowCart"><i class="material-icons">&#xe547;</i><em class="badge badge_color_1" v-if="cartCount">{{cartCount}}</em></router-link> -->
    <!-- <router-link class="btn btn_me" title="我" :to="{name: 'Me'}" v-show="innerShowMe"><i class="material-icons">&#xe7fd;</i></router-link> -->
    <!--<a class="btn btn_back" title="返回上一页" @click="funBack"><i class="material-icons">&#xe5c4;</i></a>-->
    <!-- <a class="btn btn_refresh" title="刷新页面" @click="funReload"><i class="material-icons">&#xe5d5;</i></a> -->
    <slot name="extra">
    </slot>
  </div>
  <!-- 反馈 开始 -->
  <Feedback ref="Feedback"></Feedback>
  <!-- 反馈 结束 -->
</div>
</template>

<script>

import { mapState } from 'vuex';
import Feedback from './Feedback';

export default {
  name: 'FloatTools',
  components: {Feedback},
  props: ['showScrollToTop', 'showBackHome', 'showSearchSet', 'feedbackData'],
  data () {
    return {
      innerShowScrollToTop: false,//回顶部
      innerShowBackHome: true,//回到首页
      innerShowSearchSet: true,//搜索套组
      // innerShowCart: true,
      // innerShowMe: true,
      backhomeUrl: '/',
      tmpName: 'FloatTools',
    }
  },
  computed: {
    ...mapState({
      cartCount: state => state.cartCount
    }),
  },
  watch: {

    //是否显示【回顶部】
    showScrollToTop: {
      handler(newName, oldName) {
        const _this = this;
        if( typeof newName != 'undefined' ){
          if( newName ){
            _this.innerShowScrollToTop = true;
          } else {
            _this.innerShowScrollToTop = false;
          }
        }
      },
      immediate: true
    },

    //是否显示【回首页】
    showBackHome: {
      handler(newName, oldName) {
        const _this = this;
        if( typeof newName != 'undefined' ){
          if( newName ){
            _this.innerShowBackHome = true;
          } else {
            _this.innerShowBackHome = false;
          }
        }
      },
      immediate: true
    },

    //是否显示【搜索套组】
    showSearchSet: {
      handler(newName, oldName) {
        const _this = this;
        if( typeof newName != 'undefined' ){
          if( newName ){
            _this.innerShowSearchSet = true;
          } else {
            _this.innerShowSearchSet = false;
          }
        }
      },
      immediate: true
    },


    //反馈
    feedbackData: {
      handler(newName, oldName) {
        const _this = this;
        if( typeof newName != 'undefined' ){
          if( newName ){
            _this.feedbackData = newName;
          } else {
            _this.feedbackData = null;
          }
        }
      },
      immediate: true
    },


  },
  created() {
    const _this = this;

    
    // if( typeof _this.showScrollToTop != 'undefined' ){console.log(_this.showScrollToTop);
    //   if( _this.showScrollToTop ){
    //     _this.innerShowScrollToTop = true;
    //   } else {
    //     _this.innerShowScrollToTop = false;
    //   }
    // }

    // //是否显示【回首页】
    // if( typeof _this.showBackhome != 'undefined' ){
    //   if( _this.showBackhome ){
    //     _this.innerShowBackhome = true;
    //   } else {
    //     _this.innerShowBackhome = false;
    //   }
    // }

    //是否显示【搜索套组】
    // if( typeof _this.showSearchSet != 'undefined' ){
    //   if( _this.showSearchSet ){
    //     _this.innerShowSearchSet = true;
    //   } else {
    //     _this.innerShowSearchSet = false;
    //   }
    // }

    // //是否显示【购物车】
    // if( typeof _this.showCart != 'undefined' ){
    //   if( _this.showCart ){
    //     _this.innerShowCart = true;
    //   } else {
    //     _this.innerShowCart = false;
    //   }
    // }
    // if( _this.innerShowCart ){
    //   _this.funForceUpdate();//拉取购物车商品数量
    // }

    // //是否显示【我的】
    // if( typeof _this.showMe != 'undefined' ){
    //   if( _this.showMe ){
    //     _this.innerShowMe = true;
    //   } else {
    //     _this.innerShowMe = false;
    //   }
    // }

    //总部角色不显示【购物车】
    //if( _this.GLOBAL.loginUser.roletype == 2 ) _this.innerShowCart = false;

  },
  mounted() {
  },
  destroyed() {},
  methods: {
    funBack(){
      this.$router.go(-1);
    },
    funReload(){
      location.reload(true);
    },
    //拉取购物车商品数量，并强制刷新
    // funForceUpdate(){
    //   const _this = this;
    //    _this.getCartCount(function(){
    //     _this.$forceUpdate();
    //   });//拉取购物车商品数量
    // },

    //滚到页面顶部
    funScrolltop(){
      const _this = this;
      _this.scrollToTop(300, 0);
    },



    //弹出反馈面板
    funFeedback(data){
      const _this = this;
      if( data ){
        _this.$refs.Feedback.hideSubplateFeedback(false, data);
      } else {
        _this.$refs.Feedback.hideSubplateFeedback(false, _this.feedbackData);
      }
    },


  }
}
</script>

<style lang="less">
/** 右下角浮动按钮 通用 **/
.float_tools {
  display: block;
  position: fixed;
  right: 0;
  bottom: 60px;
  z-index: 10;
  font-size: 0;
  width: 40px;
  .btn {
    /*border-radius: 100px;*/
    width: 80px;
    height: 40px;
    padding-right: 40px;
    line-height: 40px;
    opacity: .9;
    background-color: #333;
    color: #fff;
    margin-top: 5px;
    position: relative;
    transition: all .3s;
    & > .material-icons {
      line-height: inherit;
      vertical-align: top;
    }
    &:hover {
      opacity: 1;
      transform: translateX(-5px);
    }
    & > .badge {
      position: absolute;
      padding: 0 4px;
      min-width: 24px;
      text-align: center;
      border-radius: 100px;
      transform: scale(0.8);
      top: -5px;
      right: 35px;
    }
  }
  .btn_scroll_to_top {
    /*display: none;*/
    &.active {
      display: block;
      animation: scroll_to_top_ani .3s ease-out ;
    }
  }

  .btn_backhome {
    background-color: #e62828;/*#4E66FF*/
  }
  .btn_cart {
    /*background-color:#ff7e00;*/
  }
  .btn_favorite {
    background-color: rgba(239, 58, 58, .5);
    text-shadow: 0 0 10px #ef3a3a;
    box-shadow: inset 0 0 20px rgba(239, 58, 58, .5);
    &.active {
      background-color: #ef3a3a;
      color: #fff;
      text-shadow: none;
    }
    &.active .no,
    .ok {
      display: none;
    }
    &.active .ok {
      display: inline-block;
    }
    &.active {
      animation: scroll_to_top_ani .3s ease-out ;
    }
  }
  .btn_me {
    background-color: #4e66ff;
  }
  .btn_search {
    background-color: #00bf2e;
  }

  .btn_feedback {
    height: unset;
    span {
      display: block;
      line-height: 20px;
      margin: -10px 0 5px;
    }
  }


  @keyframes scroll_to_top_ani {
    0% {
      transform: scale(0);
    }
    80% {
      transform: scale(1.2);
    }
    100% {
      transform: scale(1);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/FloatTools.vue